module.exports = __webpack_public_path__ + "static/media/logo@3x.a31e8548.png";